<template>
  <div class="container">
    <div class="col-md-4 offset-md-4">
      <div class="center-container text-xs-left">
        <h1 class="title is-1">{{ $t("new-tournament") }}</h1>

        <div class="p-mt-3">
          <p class="p-my-2 title is-5">
            {{ $t("choose-division-or") }}
            <router-link to="/divisions/new?return=/tournaments/new">{{ $t("create-new-division") }}</router-link>
          </p>
        </div>

        <div class="p-grid p-text-left">
          <div
            v-for="d in $store.getters.currentSeason.divisions"
            :key="d.id"
            class="p-col-12 rounded whiteBg paddedCol p-my-3 cursorpointer"
            style="border: 1px solid rgba(0,0,0,0.3); border-radius: 5px;"
            @click="tryTournament(d)"
          >
            <h2 class="title is-2">
              <div class="colorBall" v-bind:style="{ background: d.color || '#FFFFFF' }" />
              {{ d.name }}
            </h2>

            <div>{{ $t("teams-d-teams-length", [d.teams.length]) }}</div>

            <div v-for="t in d.teams" :key="t.id">
              <div class="colorBall" v-bind:style="{ background: d.color || '#FFFFFF' }" />
              {{ t.name }}
            </div>

            <div v-if="d.teams.length < 2">
              <br />
              <p style="color: darkred; font-weight: bold">
                {{ $t("not-enough-teams") }}
              </p>
              <Button
                @click.stop="goRouter(`/teams/new?division_id=${d.id}&return=/tournaments/new`)"
                :label="$t('add-team')"
                class="p-button-text p-button-sm"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    tryTournament(division) {
      if (division.teams.length < 2) {
        return this.makeToast(
          "info",
          this.$t("Toast.please-add-at-least-2-teams-to-a-division-before-creating-a-tournament"),
        );
      }
      this.goRouter(`/calendar?td=${division.id}`);
    },
  },
};
</script>
